export const useCTAButtonLink = (partner: string) => {
  const partnerToPath = partner.toLowerCase().replace(/_/g, "-");
  const fallbackRoute = `/integrations/connect/${partnerToPath}`;

  const routes: { [key: string]: string } = {
    Get_Started_Flow: "/pipeline/basic",
    Get_Started_Flow_GFA: "/gfa-pipeline/basic",
  };

  return routes[partner] ?? fallbackRoute;
};
